import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { CrossChunky } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { BarButton } from './BarButton';
import { ModalType } from './constants';
import styles from './CloseButton.module.scss';

export interface CloseButtonProps {
    customClassName?: string;
    customIcon?: (props) => JSX.Element;
    hasBackgroundColor?: boolean;
    onClose?: (e: React.MouseEvent) => void;
    type?: ModalType;
}

export const CloseButton: FunctionComponent<CloseButtonProps> = ({
    customClassName,
    customIcon,
    hasBackgroundColor = false,
    onClose,
    type,
}) => {
    if (!onClose) {
        return null;
    }

    const IconType = customIcon ?? CrossChunky;

    const isTakeoverModal = type === ModalType.takeover;
    const takeoverButton = isTakeoverModal ? (
        <div className={styles.takeoverButton}>
            <BarButton onClick={onClose} />
        </div>
    ) : null;

    const wrapperClassNames = classNames(
        styles.edsModalCloseButton,
        {
            [styles.edsModalCloseButtonTakeover as string]: !!takeoverButton,
        },
        customClassName,
    );

    return (
        <>
            {takeoverButton}
            <div className={wrapperClassNames}>
                <IconButton
                    data-automation="modal-close-button"
                    data-spec="close-button"
                    onClick={onClose}
                    iconType={<IconType />}
                    title={gettext('Close')}
                    isOverImage={hasBackgroundColor}
                />
            </div>
        </>
    );
};
